const Impressum = () => {
  return (
    <div>
      <p>Surfanzeigen wird betrieben von:</p>
      <p>Name: Jonathan Patzwaldt</p>
      <p>Adresse: Moltkestrasse 23, 23564 Lübeck Deutschland</p>
      <p>E-Mail-Adresse: kontakt@surfanzeigen.de</p>
    </div>
  );
};
export default Impressum;
